import { SlArrowDown } from 'react-icons/sl'
export default function Tips() {
  return (
    <div className="faq tips container">
      <h3>نصيحة أمان مهمة للاختبار  </h3>
      <ul>
        <li> <p>لكل سؤال ، ابحث دائمًا عن الإجابة التي تحتوي على عنصر أو عناصر يمكنها منع وقوع حادث. </p></li>
        <li><p>تم سن جميع لوائح المرور وجميع قواعد الحذر والسلامة على الطرق بهدف واحد: <span className='text-color-primary-light text-sm'>  الحفاظ على الحياة وتعزيز السلامة في مواقف القيادة المختلفة. </span></p></li>
        <li><p>لذلك ، اسأل نفسك فيما يتعلق بكل سؤال:<span className='text-color-primary-light text-sm'>  ما هو الجواب لمنع وقوع حادث؟ واختارها.</span></p></li>

      </ul>
      <p className="text-color-primary-light">ثلاثة أمثلة</p>

      {/* Qusetions  */}


      <div className="question">
        <p><strong>كيف يجب أن تقود وأنت تسير أمامك سيارة تشير في مؤشر الاتجاه؟</strong> </p>
        <ol>
          <li>
            <h4 className='text-color-primary'> يجب أن تسمح لسائق السيارة التي أمامك بتنفيذ الإجراء الذي أشرت من أجله.</h4>
            <p>تحليل الجواب: هل الجواب آمن؟ بالتاكيد! لأنه من أجل السلامة ، يلتزم السائق بعدم إزعاج المارة الآخرين (حتى لو تصرفوا ضد القانون). سهل ومهم في هذه الحالة حيث يقوم السائق بالإشارة ويتصرف وفقًا للقانون. اجابة صحيحة </p>
            </li>
          <li>
            <h4 className='text-color-primary'> يجب عليك زيادة سرعة قيادتك لتقليل الوقت الذي قد يقع فيه حادث بينك وبين السيارة التي أمامك. </h4>
            <p> تحليل الجواب: خطير للغاية !!! يعني تقصير الوقت أيضًا تقصير المسافة وبالتالي يزيد خطر الاصطدام. يحظر الرد على حادث على الطريق عن طريق زيادة السرعة.</p>
          </li>
          <li>
            <h4 className='text-color-primary'> يمكنك مواصلة رحلتك دون إبطاء. تقع المسؤولية على عاتق سائق الإشارات. </h4>
            <p> تحليل الإجابة: حتى في حالة تصرف أحد المارة ضد القانون ، يجب عدم نقل المسؤولية إلى شخص آخر. تقع مسؤولية القيادة بحذر ومسؤولية أولاً وقبل كل شيء على عاتقك أنت السائق. </p>
          </li>
          <li>
            <h4 className='text-color-primary'> يجب أن تلتزم بالجانب الأيمن من الطريق. </h4>
            <p> تحليل الإجابة: وفقًا للقانون ، يجب أن تقود سيارتك على اليمين في كل طريق. ومع ذلك ، في الحالة المعروضة علينا ، لا تتعلق هذه اللائحة بالسؤال ولا تشكل إجابة عليه. كما أوضحنا ، في كثير من الأحيان تجمع إحدى الإجابات بين المكونات الصحيحة وبالتالي فهي مربكة.</p>
          </li>

        </ol>
      </div>


      <div className="question">
        <p><strong>ما الذي يجب عليك التحقق منه قبل البدء في الانعطاف يمينًا؟</strong> </p>
        <ol>
          <li>
            <h4 className='text-color-primary'> أنه لا توجد مركبة تتحرك إلى يسارك. </h4>
            <p> تحليل الإجابة: لا يمكن للمركبة التي تتحرك إلى يساري أن تزعجني عندما أستدير لليمين ، فهذان اتجاهان متعاكسان ، لذا فإن هذه الإجابة ليس لها قيمة أمان وهي غير صحيحة. </p>
          </li>
          <li>
            <h4 className='text-color-primary'> أن مرآتك اليمنى محاذاة بشكل صحيح.</h4>
            <p> تحليل الإجابة: من المهم بموجب القانون توجيه المرآة بشكل صحيح ، فهذه الإجابة تحتوي على مكون صحيح ولكنها لا توفر الأمان. نسأل أنفسنا: هل هناك إجابة يكون فيها عنصر الأمان أكثر أهمية وأهمية؟ </p>
          </li>
          <li>
            <h4 className='text-color-primary'> أنه لا توجد مركبة تتحرك إلى يمينك.</h4>
            <p> تحليل الإجابة: للإجابة عنصر أمان مباشر: إذا لم ألاحظ وجود سيارة على يميني ، فقد يقع حادث أثناء الانعطاف يمينًا. اجابة صحيحة </p>
          </li>
          <li>
            <h4 className='text-color-primary'> أنه لا توجد مركبة متوقفة على الجانب الأيسر. </h4>
            <p> تحليل الإجابة: السيارة المتوقفة على الجانب الأيسر لا يمكن أن تصطدم بي عند الانعطاف يمينًا ، فهذه اتجاهات متعاكسة ، لذا لا توجد مشكلة تتعلق بالسلامة هنا. </p>
          </li>

        </ol>
      </div>
      <div className="question">
        <p><strong>تقترب مركبتان من اتجاهين متعاكسين على امتداد ضيق وشديد الانحدار من الطريق حيث يمكن لمركبة واحدة فقط المرور في كل مرة. كيف يجب أن يقودوا؟</strong> </p>
        <ol>
          <li>
            <h4 className='text-color-primary'>يجب أن تتوقف المركبة الصاعدة وتسمح للمركبة الهابطة بالمرور.  </h4>
            <p>تحليل الجواب: خطير! قد تنزلق المركبة الصاعدة على المنحدر وفي هذه الحالة لا يكون لها مجال رؤية مفتوح ويكون الرجوع للخلف في غاية الخطورة.</p>
          </li>
          <li>
            <h4 className='text-color-primary'> يجب أن تتوقف كلتا السيارتين. </h4>
            <p>تحليل الجواب: لا توجد معلومات عن هوامش السؤال ولا يجوز استنتاج بيانات غير موجودة في صلب السؤال ، فالسؤال ينص صراحة على أنه يمكن لمركبة واحدة فقط المرور في المرة الواحدة.</p>
          </li>
          <li>
            <h4 className='text-color-primary'> يجب أن تتوقف السيارة الهابطة وتسمح للمركبة الصاعدة بالمرور.  </h4>
            <p> تحليل الإجابة: الخيار الأكثر أمانًا لأنه في حالة تدهور المركبة الهابطة ، يكون أمامها مجال رؤية مفتوح. اجابة صحيحة</p>
          </li>
          <li>
            <h4 className='text-color-primary'> يجب إعطاء حق المرور للمركبة التجارية التي يزيد وزنها عن أربعة أطنان.  </h4>
            <p> تحليل الجواب: لا يوجد مثل هذا التنظيم ، ولكن حتى لو كنت لا تعرف ذلك ، فإن السؤال كان حول المركبات بشكل عام والإجابة لا تجيب على تنوع المركبات. </p>
          </li>
        </ol>
      </div>
      <div className="question">
        <p><strong>يتم تقديم طلب للحصول على رخصة قيادة عبر الإنترنت. يجب عليك ملء نموذج "طلب إصدار رخصة قيادة" على موقع وزارة النقل. إذا تم العثور على كل شيء على ما يرام ، فسيتم إرسال رسالة نصية إلى طالب الترخيص مع الإذن بالتسجيل في الاختبار النظري (الاختبار النظري).</strong> </p>
        <p><strong>في يوم الامتحان النظري ، يجب أن تصل مع بطاقة هوية / جواز سفر ساري المفعول / رخصة قيادة سارية / شهادة حزام / شهادة ضابط / شهادة شرطي - لن تتم الموافقة على دخول الاختبار بدون الشهادة الصالحة المذكورة أعلاه .</strong> </p>
        <p><strong>كجزء من إرشادات الحكومة الإسرائيلية لمكافحة فيروس كورونا من خلال التباعد الاجتماعي والحد من الاتصال ، حتى إشعار آخر ، لا يمكن الدفع إلا عن طريق الطلب المسبق عبر الإنترنت أو في مركز الخدمة اعتمادًا على الفرع المطلوب.</strong> </p>
        <p><strong>يمكن اختبار كل ممتحن مرة واحدة في اليوم لمستوى ترخيص معين.</strong> </p>
      </div>
    </div>
  )
}
